import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Oktober",
  "description": "",
  "published": "2006-10-17T00:00:00.000Z",
  "redirect_from": ["/blog/oktober/swizec/377"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Skrajni Äas Å¾e, da ta blog dobi en malÄek novejših vsebin. Je Å¾e skoraj smrdelo po plesnivem siru in trohneÄi barvi. Nasploh nelepo. Na Å¾alost pa niti ni kaj veliko za povedat, ker se paÄ ni prav veliko zgodilo, kaj Ämo.`}</p>
    <p>{`Stran s `}<a parentName="p" {...{
        "href": "http://swizec.com//index.php/mode=pages/submode=Links"
      }}>{`povezavami`}</a>{` je bila na manjši plastiÄni operaciji, upam, da bo lahko poplaÄala kredit. Sedaj je na splošno boljša, je pa obljubila, da si bo pridobila še pvoezave na nekaj drugih odliÄnih stripov, katerih avtorji pa ne dobavljajo lastnih banerjov, tako da, ker stvar rabi malo veÄ pozornosti, to preprosto še ni bilo postorjeno.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/05_prev.jpg",
        "alt": null
      }}></img></p>
    <p>{`Cthulhu se je tudi zredil za še eno stran za Oktober, kar je še dobro, ker se je zgodilo nekako ravno na sredi meseca, kar pomeni, da je bil dogodek takorekoÄ ravno po naÄrtu. Redko a fascinantno.`}</p>
    <p>{`Pripelje nas to torej do naslednje relativno pomembne teme. Pod novo stranjo lahko opazite, da datum naslednje rasti ni v Novembru, kot bi se priÄakovalo, ampak nekako šele v Decembru. Za taka hudodelstva so seveda dobri razlogi in zaobsegajo doloÄene dogodke, ki bodo potekali cel mesec. Seveda pa vam lahko Å¾e narava t.i cliffhangerja pove, da še ne boste zvedeli, kaj to pravzaprav je.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      